import { type FunctionComponent, useCallback } from "react";

import type { ArticlesSearchOrderByInput } from "scmp-app/queries/__generated__/searchArticleResultPaginationQuery.graphql";

import { FieldGroup, FieldLabel, PillActive, PillInactive, PillRow } from "./styles";

const MostRecentOrderBy: ArticlesSearchOrderByInput = {
  direction: "DESC",
  field: "PUBLISHED_DATE",
};
const RelevanceOrderBy: ArticlesSearchOrderByInput = { field: "RELEVANCE" };

type Props = {
  className?: string;
  onChange: (orderBy: ArticlesSearchOrderByInput) => void;
  value?: ArticlesSearchOrderByInput;
};

export const SortByToggle: FunctionComponent<Props> = ({ className, onChange, value }) => {
  // `undefined` (default) is treated as Relevance, matching the previous DefaultSortingOption.
  const isMostRecent = value?.field === "PUBLISHED_DATE";

  const handleRelevanceClick = useCallback(() => {
    onChange(RelevanceOrderBy);
  }, [onChange]);

  const handleMostRecentClick = useCallback(() => {
    onChange(MostRecentOrderBy);
  }, [onChange]);

  const RelevanceComponent = isMostRecent ? PillInactive : PillActive;
  const MOstRecentComponent = isMostRecent ? PillActive : PillInactive;

  return (
    <FieldGroup className={className}>
      <FieldLabel>Sort By</FieldLabel>
      <PillRow>
        <RelevanceComponent onClick={handleRelevanceClick} type="button">
          Relevance
        </RelevanceComponent>
        <MOstRecentComponent onClick={handleMostRecentClick} type="button">
          Most Recent
        </MOstRecentComponent>
      </PillRow>
    </FieldGroup>
  );
};

SortByToggle.displayName = "SortByToggle";
